<template>
    <div>
      <div class="mt-5 table-responsive table-wrapper">
        <table class="table table-bordered">
          <!-- Gambar versi mobile -->
          <div class="mobile-img-wrapper d-block d-md-none">
            <img
              :src="getImageUrl(itemLendings.sub_brand.images[0].image)"
              alt="img-product"
              class="mobile-img"
            />
          </div>
  
          <!-- Header -->
          <thead>
            <tr>
              <th colspan="3">
                <div class="d-flex justify-content-between align-items-center px-3">
                  <h2 class="product-name">{{ itemLendings.sub_brand.name }}</h2>
                  <div class="d-flex flex-column align-items-end">
                    <p class="product-sub-title mb-0">Cakupan Wilayah</p>
                    <div class="d-flex flex-wrap justify-content-end" style="max-width: 300px;">
                      <p
                        v-for="(kota, index) in location"
                        :key="index"
                        class="product-description mb-0 ml-2"
                        style="white-space: nowrap;"
                      >
                        {{ kota.name }}<span v-if="index !== location.length - 1">,</span>
                      </p>
                    </div>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
  
          <!-- Body -->
          <tbody>
            <tr>
              <!-- Gambar versi desktop -->
              <td rowspan="2" class="d-none d-md-table-cell">
                <div class="img-container">
                  <img
                    :src="getImageUrl(itemLendings.sub_brand.images[0].image)"
                    alt="img-product"
                    class="img-product"
                  />
                </div>
              </td>
              <td colspan="2">
                <div class="row">
                  <div class="row col-12">
                    <div class="col-12 col-lg-6">
                      <div
                        class="d-flex justify-content-between"
                        v-for="(spec, index) in firstColumnSpecs"
                        :key="'first-' + index"
                      >
                        <p class="product-description font-weight-bold mb-0 w-50 text-left">{{ spec.label }}</p>
                        <p class="product-description mb-0 w-50 text-left">{{ spec.value }}</p>
                      </div>
                    </div>
                    <div class="col-12 col-lg-6" v-if="secondColumnSpecs.length > 0">
                      <div
                        class="d-flex justify-content-between"
                        v-for="(spec, index) in secondColumnSpecs"
                        :key="'second-' + index"
                      >
                        <p class="product-description font-weight-bold mb-0 w-50 text-left">{{ spec.label }}</p>
                        <p class="product-description mb-0 w-50 text-left">{{ spec.value }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
  
            <tr>
              <td class="align-middle">
                <div class="installment-container">
                  <p class="text-installment">Angsuran mulai dari</p>
                  <p class="text-installment font-weight-bold">{{ formatRupiah(itemLendings.max_installment) }}*</p>
                </div>
              </td>
              <td class="align-middle">
                <div class="installment-container">
                  <p class="text-installment">Total Uang Muka mulai dari</p>
                  <p class="text-installment font-weight-bold">
                    {{ formatRupiah(itemLendings.down_payment) }}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <!-- Keterangan asuransi Pindah ke Luar -->
      <p class="product-description text-left mt-n3">*Sudah termasuk biaya asuransi</p>
    </div>
  </template>
  
  <script>
  export default {
    name: 'CardDetailProduk',
    props: {
      itemLendings: {
        type: Object,
        required: true
      },
      location: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      firstColumnSpecs() {
        return this.itemLendings.sub_brand.specifications.slice(0, 3) || [];
      },
      secondColumnSpecs() {
        return this.itemLendings.sub_brand.specifications.slice(3) || [];
      }
    },
    methods: {
      getImageUrl(item) {
        return item ? process.env.API_URL + item : '';
      },
      formatRupiah(value) {
        if (!value) return 'Rp 0';
        return 'Rp ' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    }
  };
  </script>
  <style scoped>
  .table-wrapper {
    border: 1px solid #dee2e6;
    border-radius: 12px;
    overflow: hidden;
    background-color: white;
  }
  .product-name {
    font-size: 40px;
    font-weight: 600;
    color: #13346c;
    text-transform: capitalize;
  }
  .product-sub-title {
    font-size: 20px;
    font-weight: 600;
    color: #13346c;
    text-transform: capitalize;
  }
  .product-description {
    font-size: 16px;
    color: #b3b3b3;
    font-weight: 400;
  }
  .text-installment {
    font-size: 20px;
    font-weight: 400;
    color: #13346c;
    text-align: center;
  }
  .installment-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
  }
  .img-container {
    height: 250px;
    width: 100%;
    max-width: 300px;
    margin: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }
  .img-product {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }
  .mobile-img-wrapper {
    width: 100%;
    padding: 16px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .mobile-img {
    width: auto;
    max-width: 90%;
    height: auto;
    max-height: 250px;
    object-fit: contain;
  }
  @media (max-width: 768px) {
    .product-name {
      font-size: 32px;
    }
    .product-sub-title {
      font-size: 16px;
    }
    .product-description {
      font-size: 14px;
    }
    .text-installment {
      font-size: 14px;
    }
  }
  </style>


// WEBPACK FOOTER //
// src/components/CardDetailProduk.vue